module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_3_1.30f66e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_3_1.png
// module id = k2cx
// module chunks = 34